import { makeStyles } from '@material-ui/core/styles';
import { deepOrange } from '@material-ui/core/colors';

export default makeStyles((theme) => ({
	appBar: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '10px 50px',
		background: 'transparent',
		[theme.breakpoints.down('sm')]: {
			flexDirection: 'column',
		},
	},
	heading: {
		color: theme.palette.primary.main,
		textDecoration: 'none',
		fontSize: '2em',
		fontWeight: 300,
	},
	image: {
		marginLeft: '10px',
		marginTop: '5px',
	},
	toolbar: {
		display: 'flex',
		justifyContent: 'flex-end',
		width: '400px',
		[theme.breakpoints.down('sm')]: {
			width: 'auto',
		},
	},
	profile: {
		display: 'flex',
		justifyContent: 'space-between',
		width: '400px',
		alignItems: 'center',
		[theme.breakpoints.down('sm')]: {
			width: 'auto',
			marginTop: 20,
			justifyContent: 'center',
		},
	},
	logout: {
		marginLeft: theme.spacing(2),
	},
	userName: {
		display: 'flex',
		marginLeft: '5px',
		alignItems: 'center',
		textAlign: 'center',
	},
	brandContainer: {
		display: 'flex',
		alignItems: 'center',
	},
	purple: {
		textTransform: 'uppercase',
		color: theme.palette.getContrastText(deepOrange[500]),
		backgroundColor: deepOrange[500],
		marginLeft: theme.spacing(2),
	},
	navigationContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	listItem: {
		cursor: 'pointer',
		paddingTop: 0,
		paddingBottom: 0,
	},
	listItemText: {
		flex: '0 0 auto',
		fontWeight: '400',
		whiteSpace: 'nowrap',
		textDecoration: 'none',
		textTransform: 'uppercase',
	},
}));
